import React from "react";
import { columnsPortableTab } from "./columnsPortableTab";
import { StorageTable } from "./StorageTable";
import { StationaryTable } from "./StationaryTable";
import { MobileTable } from "./MobileTable";
import { ShipmentTable } from "./ShipmentTable";
import { StationTable } from "./StationTable";
import { columnsStation_actual, columnsStation_actual_tanks } from "./columnsStation";
import { columnsShipment } from "./columnsShipment";

export const newInventoryTabs = [
  {
    label: 'Almacenes',
    content: () => (
      <StorageTable
        title="Inventario Almacenes"
        type="ALMACENES"
        keyInventory="storagesInventory"
        endpoint="storage"
        edited='storagesInventory_edited'
      />
    ),
    type: "ALMACENES",
    edited: 'storagesInventory_edited',
    keyInventory: "storagesInventory",
    endpoint: "storage"
  },
  {
    label: 'Autotanques',
    content: () => (
      <StationaryTable
        title="Inventario Estacionario"
        type="ESTACIONARIO"
        keyInventory="stationaryInventory"
        endpoint="stationary"
        edited='stationaryInventory_edited'
      />
    ),
    type: "ESTACIONARIO",
    edited: 'stationaryInventory_edited',
    keyInventory: "stationaryInventory",
    endpoint: "stationary"
  },
  {
    label: 'Tanques',
    content: () => (
      <StationTable
        title="Inventario Estacion"
        type="ESTACION"
        keyInventory="localInventory"
        endpoint="local"
        edited="localInventory_edited"
        columns={columnsStation_actual_tanks}
      />
    ),
    type: 'ESTACION',
    edited: 'localInventory_edited',
    keyInventory: "localInventory",
    endpoint: "local"
  },
  {
    label: 'Portatiles',
    content: () => (
      <MobileTable
        title="Inventario Portatil"
        type="PORTATIL"
        columns={columnsPortableTab}
        keyInventory="mobileInventory"
        endpoint="mobile"
        edited="mobileInventory_edited"
      />
    ),
    type: 'PORTATIL',
    edited: 'mobileInventory_edited',
    keyInventory: "mobileInventory",
    endpoint: "mobile"
  },
  {
    label: 'Embarques',
    content: () => (
      <ShipmentTable
        title="Inventario Embarques"
        type="SHIPMENT"
        columns={columnsShipment}
        keyInventory="shipmentInventory"
        endpoint="shipment"
        edited="shipmentInventory_edited"
      />
    ),
    type: 'SHIPMENT',
    edited: 'shipmentInventory_edited',
    keyInventory: "shipmentInventory",
    endpoint: "shipment"
  },
];
